import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import i18n from './locales/i18n';
import { store } from 'redux/store';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { ErrorBoundary } from 'react-error-boundary';
import FallbackErrorBoundary from 'components/FallbackErrorBoundary/FallbackErrorBoundary';

/*
 * Get the root element from the DOM and check if it already exists
 */
const mainApp = document.getElementById('root');
if (mainApp) {
  const root = createRoot(mainApp);
  root.render(
    <I18nextProvider i18n={i18n}>
      <StrictMode>
        <BrowserRouter>
          <Provider store={store}>
            <ErrorBoundary fallback={<FallbackErrorBoundary />}>
              <App />
            </ErrorBoundary>
          </Provider>
        </BrowserRouter>
      </StrictMode>
    </I18nextProvider>,
  );
} else {
  throw new Error("The element #root wasn't found");
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
